/**
 * Aggregator that looks to see if all grouped item values are the same and returns that value.
 */
export function allTheSameAggregator(itemValues: any[]): any {
  return itemValues.every((itemValue) => itemValue === itemValues[0])
    ? itemValues[0]
    : "";
}

/**
 * Aggregator that sums the values. Unparsable values will default to 0.
 */
export function summingAggregator(itemValues: any[]): any {
  if (!itemValues.length) {
    return 0;
  }

  return itemValues.reduce(
    (currentSum, itemValue) => currentSum + Number(itemValue) || 0,
    0
  );
}
